export { default } from './NewsPageView';



// WEBPACK FOOTER //
// ./src/components/views/NewsPageView/index.js